import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import {
  DataTable,
  DropDown,
  DropDownItem,
  Icon
} from "MODULES/shared/components";
import { dollars } from "LIB/formatters/currency";
import Form from "./Form";
import EditForm from "./EditForm";

function dropdown(setEditingQuarterlyGoal, r) {
  return (
    <td
      className="text-center td-shrink-icon"
      onClick={e => e.stopPropagation()}
    >
      <DropDown
        icon="fa fa-fw fa-ellipsis-v"
        menuClass="dropdown-menu-right large"
      >
        <DropDownItem onClick={() => setEditingQuarterlyGoal(r)}>
          <Icon name="edit" fixed />
          <span className="with-padding">Edit</span>
        </DropDownItem>
      </DropDown>
    </td>
  );
}

function renderRow(r, mostRecent, setEditingQuarterlyGoal) {
  return (
    <tr key={r.id}>
      <td>{r.year}</td>
      <td>Quarter {r.quarter}</td>
      <td>{dollars(r.amount)}</td>
      {mostRecent ? dropdown(setEditingQuarterlyGoal, r) : <td />}
    </tr>
  );
}

export default function Table({
  creatingQuarterlyGoal,
  setCreatingQuarterlyGoal,
  editingQuarterlyGoal,
  setEditingQuarterlyGoal,
  searchQuarterlyGoals,
  goals
}) {
  const quarter =
    goals && goals.length > 0
      ? [1, 2, 3, 4, 1][moment().quarter()]
      : moment().quarter();
  const year =
    moment().quarter() + 1 > 4 ? moment().year() + 1 : moment().year();
  const initialValues = {
    year,
    quarter,
    amount: 0
  };

  return (
    <React.Fragment>
      {!editingQuarterlyGoal &&
        creatingQuarterlyGoal && (
          <Form
            close={() => setCreatingQuarterlyGoal(false)}
            setCreatingQuarterlyGoal={setCreatingQuarterlyGoal}
            searchQuarterlyGoals={searchQuarterlyGoals}
            initialValues={initialValues}
            enableReinitialize
          />
        )}
      {editingQuarterlyGoal &&
        !creatingQuarterlyGoal && (
          <EditForm
            close={() => setEditingQuarterlyGoal(null)}
            setEditingQuarterlyGoal={setEditingQuarterlyGoal}
            quarterlyGoal={editingQuarterlyGoal}
            searchQuarterlyGoals={searchQuarterlyGoals}
            initialValues={{
              year: editingQuarterlyGoal.year,
              quarter: editingQuarterlyGoal.quarter,
              amount: editingQuarterlyGoal.amount
            }}
            enableReinitialize
          />
        )}
      {!editingQuarterlyGoal &&
        !creatingQuarterlyGoal && (
          <DataTable loading={false} refresh={() => {}}>
            <DataTable.Head>
              <th>Year</th>
              <th>Quarter</th>
              <th>Amount</th>
              <th />
            </DataTable.Head>
            <DataTable.Body>
              {goals.map((r, idx) =>
                renderRow(r, idx === 1 || idx === 0, setEditingQuarterlyGoal)
              )}
            </DataTable.Body>
          </DataTable>
        )}
    </React.Fragment>
  );
}

Table.propTypes = {
  creatingQuarterlyGoal: PropTypes.bool.isRequired,
  setCreatingQuarterlyGoal: PropTypes.func.isRequired,
  editingQuarterlyGoal: PropTypes.bool.isRequired,
  setEditingQuarterlyGoal: PropTypes.func.isRequired,
  searchQuarterlyGoals: PropTypes.func.isRequired,
  goals: PropTypes.shape({
    year: PropTypes.number.isRequired,
    quarter: PropTypes.number.isRequired,
    amount: PropTypes.number.isRequired
  })
};



// WEBPACK FOOTER //
// ./app/modules/QuarterlyGoals/Table.jsx